import {
    ChangeDetectionStrategy,
    Component,
    OnDestroy,
    OnInit,
} from '@angular/core';
import {CustomPagesIndexComponent} from '@common/pages/custom-pages-index/custom-pages-index.component';
import {Settings} from '@common/core/config/settings.service';
import {DatatableService} from '@common/datatable/datatable.service';
import {CustomPage} from '@common/core/types/models/CustomPage';
import {CurrentUser} from '@common/auth/current-user';
import {Pages} from '@common/pages/shared/pages.service';
import {Toast} from '@common/core/ui/toast.service';
import {ActivatedRoute, Router} from '@angular/router';
import {LINK_PAGE_BASE_URI} from '../link-page-base-uri';
import {CUSTOM_PAGE_FILTERS} from '@common/pages/custom-pages-index/cusomt-page-filters';
import {WorkspacesService} from '@common/workspaces/workspaces.service';
import {ActiveAppSectionService} from '../active-app-section.service';
import {Subscription} from 'rxjs';

@Component({
    selector: 'link-page-index',
    templateUrl: './link-page-index.component.html',
    styleUrls: ['./link-page-index.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [DatatableService],
})
export class LinkPageIndexComponent
    extends CustomPagesIndexComponent
    implements OnInit, OnDestroy
{
    private workspaceSub: Subscription;

    constructor(
        public settings: Settings,
        public datatable: DatatableService<CustomPage>,
        public currentUser: CurrentUser,
        protected customPages: Pages,
        protected toast: Toast,
        protected router: Router,
        protected route: ActivatedRoute,
        private workspaces: WorkspacesService,
        private activeSection: ActiveAppSectionService
    ) {
        super(
            settings,
            datatable,
            currentUser,
            customPages,
            toast,
            router,
            route
        );
    }

    ngOnInit() {
        this.workspaceSub = this.workspaces.activeId$.subscribe(() => {
            this.setFilters();
        });
        this.datatable.init({
            uri: LINK_PAGE_BASE_URI,
            staticParams: {
                with: ['user'],
                userId: !this.showUserColumn()
                    ? this.currentUser.get('id')
                    : null,
            },
        });
    }

    ngOnDestroy() {
        this.workspaceSub.unsubscribe();
    }

    showUserColumn(): boolean {
        // show in admin and if active workspace is not personal
        return this.activeSection.admin || !!this.workspaces.activeId$.value;
    }

    private setFilters() {
        this.filters = CUSTOM_PAGE_FILTERS.filter(
            f => f.key !== 'user_id' || this.showUserColumn()
        );
    }
}
